export default {
    // 将product.attributes转化为Table datasource格式
    setAttrTableData: (attr) => {
        let tableData = []
        if(attr && attr.attributes && attr.attributes !== {}){
            for(let key in attr.attributes){
                tableData.push({
                    key: key,
                    values: attr.attributes[key].choices
                })
            }
        }
        return tableData
    }
}